import { useCallback } from 'react'

import { Button, Modal, TermsOfService } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { GraphQLErrorBoundary } from '@shared/components/errors'
import { useOnboardingMsaOperationQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import {
  MsaModalTypeToOnboardingLevel,
  msaSanitizeOptions,
  MsaModalType,
} from '../utils'

export interface ViewMsaProps {
  /**
   * MSA type.
   */
  msaType?: MsaModalType
}

export const ViewMsa: React.FC<ViewMsaProps> = ({
  msaType = MsaModalType.core,
}) => {
  const { t } = useTranslation('developer')
  const modal = useModal()

  const { data, loading, error, refetch } = useOnboardingMsaOperationQuery({
    variables: {
      input: {
        onboardingLevel: MsaModalTypeToOnboardingLevel[msaType],
      },
    },
  })

  const handleClose = useCallback(() => {
    modal.close()
  }, [modal])

  return (
    <GraphQLErrorBoundary error={error} retry={refetch}>
      <Modal.Title>{t(`msa.${msaType}.heading`)}</Modal.Title>
      <Modal.Body className="mt-4 h-128 overflow-scroll">
        <TermsOfService loading={loading}>
          <TermsOfService.Content
            html={data?.onboardingMsaOperation?.certification?.content ?? ''}
            sanitizeOptions={msaSanitizeOptions}
          />
        </TermsOfService>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} variant="primary">
          {t`common:close`}
        </Button>
      </Modal.Footer>
    </GraphQLErrorBoundary>
  )
}
